import { renderTile } from '../ui/render.js';
import { makeTile } from '../engine/tiles.js';
import { SUITS, SUIT_NAMES, WINDS, DRAGONS } from '../engine/constants.js';
import { HANDS, SECTIONS, CARD_CREDIT } from '../engine/cards/nmjl2026.js';

export function buildReference() {
  // Tiles tab
  let h = '';
  for (const s of SUITS) {
    h += `<div class="ref-grid-label">${SUIT_NAMES[s]}s</div><div class="ref-grid">`;
    for (let n = 1; n <= 9; n++) h += renderTile(makeTile('suited', s, n), '', false);
    h += '</div>';
  }
  h += '<div class="ref-grid-label">Winds</div><div class="ref-grid">';
  for (const w of WINDS) h += renderTile(makeTile('wind', null, 0, w));
  h += '</div><div class="ref-grid-label">Dragons</div><div class="ref-grid">';
  for (const d of DRAGONS) h += renderTile(makeTile('dragon', null, 0, d));
  h += '</div><div class="ref-grid-label">Flowers &amp; Jokers</div><div class="ref-grid">';
  h += renderTile(makeTile('flower')) + renderTile(makeTile('joker'));
  h += '</div>';
  document.getElementById('ref-tiles').innerHTML = h;

  // Patterns tab — the official 2026 card
  document.getElementById('ref-patterns').innerHTML = buildPatternsHtml({ includeCredit: true });

  // Rules tab — official NMJL 2026 rules
  h = '<div class="rule-card"><h4>Tile Groups</h4><p><b>Pair</b> 2 · <b>Pung</b> 3 · <b>Kong</b> 4 · <b>Quint</b> 5 · <b>Sextet</b> 6 (5 &amp; 6 need Jokers). <b>Run</b> = consecutive numbers. 1 / 2 / 3 colors on the card = 1 / 2 / 3 suits. <b>X</b> = exposed value · <b>C</b> = concealed.</p></div>';
  h += '<div class="rule-card"><h4>White Dragon = 0</h4><p>In the year hands, the White Dragon (Soap) is used as <b>0</b> and may go with any suit.</p></div>';
  h += '<div class="rule-card"><h4>Joker Rules</h4><p>A Joker is wild in any <b>Pung, Kong, Quint or Sextet</b> — <b>never</b> in a single or a pair (e.g. NEWS, 2026, or any pair). A discarded Joker is dead and may never be picked up. On your turn you may swap a matching real tile for a Joker in any exposure. Win with <b>no Joker</b> and the hand pays double (except Singles &amp; Pairs).</p></div>';
  h += '<div class="rule-card"><h4>Claiming a Discard</h4><p>You may claim a discard only to complete a <b>Pung, Kong, Quint or Sextet</b> (an exposure) — never to complete singles or a pair — <i>except</i> to declare Mahjong.</p></div>';
  h += '<div class="rule-card"><h4>Concealed Hands</h4><p>A <b>C</b> hand makes no exposures — the whole hand stays hidden until you win.</p></div>';
  h += '<div class="rule-card"><h4>Charleston</h4><p>1st (required): Right → Across → Left. 2nd (optional): Left → Across → Right. Optional courtesy pass (0–3) with the player across. Jokers are never passed.</p></div>';
  h += '<div class="rule-card"><h4>Winning</h4><p>Complete a hand exactly as printed on the 2026 card. Call <b>“Mahjong!”</b> — it beats every other claim. A hand with too many / too few tiles, or a wrong exposure, is <b>dead</b>.</p></div>';
  document.getElementById('ref-rules').innerHTML = h;
}

// Renders the official 2026 card hands grouped by section. Used by the
// Reference screen and the in-game floating Hands card.
export function buildPatternsHtml({ includeCredit = false } = {}) {
  let h = includeCredit
    ? `<p class="card-credit" style="margin-bottom:14px;color:var(--gray);font-size:.82rem">${CARD_CREDIT}</p>`
    : '';
  for (const section of SECTIONS) {
    const hands = HANDS.filter((x) => x.section === section);
    if (!hands.length) continue;
    h += `<div class="hand-section-head" style="font-weight:700;margin:14px 0 6px;color:var(--gold);border-bottom:1px solid var(--gold);padding-bottom:3px">${section}</div>`;
    for (const p of hands) {
      h += `<div class="pattern-card"><div class="comp">${p.label}</div>` +
        `<p style="font-size:.82rem;color:#555;margin:4px 0 6px">${p.desc || ''}</p>` +
        `<div class="meta"><span class="badge badge-pts">${p.value}</span>` +
        `${p.concealed ? '<span class="badge badge-con">Concealed (C)</span>' : '<span class="badge badge-suit">Exposed (X)</span>'}</div></div>`;
    }
  }
  return h;
}

export function wireReferenceTabs() {
  document.querySelectorAll('.ref-tab').forEach((btn) => {
    btn.addEventListener('click', () => {
      selectRefTab(btn.dataset.section);
    });
  });
}

export function selectRefTab(secId) {
  document.querySelectorAll('.ref-tab').forEach((t) => {
    t.classList.toggle('active', t.dataset.section === secId);
  });
  document.querySelectorAll('.ref-section').forEach((s) => {
    s.classList.toggle('active', s.id === secId);
  });
}
